import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SpinningIcon } from '@/components/common/spinning-icon';
import { Button, ButtonVariant } from '@/components/form/button';

import { TableState } from './types';

type IProps = { state: TableState; fetchNextPage: () => void };

const BottomRow = forwardRef<HTMLDivElement, IProps>(({ state, fetchNextPage }, ref) => (
  <div className="px-7 py-7 flex items-center justify-center" ref={ref}>
    {state === 'no-data' && <NoDataComponent />}
    {state === 'loading' && <LoadingComponent />}
    {state === 'none' && <LoadMoreComponent fetchNextPage={fetchNextPage} />}
  </div>
));

const NoDataComponent = () => {
  const { t } = useTranslation();
  return (
    <span className="font-thin text-gray-500 text-sm">{t('common.noMoreData')}.</span>
  );
};

const LoadingComponent = () => {
  const theme: any = useTheme();
  const { t } = useTranslation();
  return (
    <>
      <SpinningIcon color={`fill-${theme.current}-primary`} />
      <span className="text-gray-600">{t('common.loading')}</span>
    </>
  );
};

const LoadMoreComponent = ({ fetchNextPage }: { fetchNextPage: () => void }) => {
  const { t } = useTranslation();
  return (
    <Button onClick={fetchNextPage} variant={ButtonVariant.Secondary}>
      {t('common.loadMore')}
    </Button>
  );
};

BottomRow.displayName = 'BottomRow';
export { BottomRow };
